// The toast a finished self-revoke shows. The server answers with how far the
// removal got: done, running asynchronously at the provider, or held by an
// approval gate — only the first means the access is already gone.

import type { RevokeAccessStatus } from "state/members/access_v2/catalogs";

export const revokedToastTitle = (status: RevokeAccessStatus): string => {
  switch (status) {
    case "deprovisioned":
      return "Access revoked";
    case "deprovisioning":
      return "Access is being removed";
    case "held":
      return "Removal sent for approval";
  }
};
